export default "__VITE_ASSET__M0PyUR6O__"